var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElibilityAndBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.17 129.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15788",
    d: "m109.21,93.32c-4.85,1.43-9.77,2.62-14.74,3.55-2.19,3.41-6.14,6.14-12.15,7.1-1.58.24-3.18.33-4.78.27-4.89-.12-9.77-.53-14.61-1.23-.41,0-.82-.14-1.23-.14-1.43-.16-2.47-1.44-2.32-2.87.1-1.47,1.37-2.57,2.84-2.47.05,0,.11,0,.16.02.41,0,.82.14,1.23.14,6.96.82,13.65,1.5,17.88.96,7.78-1.23,10.1-5.87,9.69-9.83-.27-3.28-2.59-6.42-6.42-6.28-5.46.27-11.88-.41-18.02-.96-7.1-.68-14.47-1.37-19.66-.68-2.87.41-7.92,2.18-13.11,4.37-1.23.55-2.46.96-3.55,1.5v34.4c10.51,3.82,23.34,7.92,30.99,8.6,15.43,1.23,45.73-16.25,54.47-21.98s2.87-17.75-6.69-14.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15789",
    d: "m21.43,80.62H3.55c-1.94.03-3.51,1.6-3.55,3.55v39.32c.03,1.95,1.6,3.51,3.55,3.55h17.88c1.95-.03,3.51-1.6,3.55-3.55v-39.32c-.03-1.95-1.6-3.52-3.55-3.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15790",
    d: "m62.53,66.42l30.58-30.58c8.23-8.14,8.3-21.4.16-29.62-8.14-8.23-21.4-8.3-29.62-.16l-.16.16-3.41,3.41-3.55-3.41C52.62,2.29,47.31.07,41.77.07c-5.71.01-11.17,2.33-15.15,6.42-7.92,8.33-7.37,21.57.68,29.62l30.31,30.31c1.34,1.36,3.53,1.37,4.89.02,0,0,0,0,0,0l.02-.02"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElibilityAndBenefits);
export default __webpack_public_path__ + "static/media/Elibility-and-Benefits.4f96c7dddaec886f56c9d9c1d71076ac.svg";
export { ForwardRef as ReactComponent };